import * as api from '../services/API';
import { actions } from '../ducks/Subscribers';
import onError from './Error';
import { Dispatch } from 'redux';

export const subscribe = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.subscribeRequest());

    try {
      await api.subscribe({ communityId, roomId, boardId, id });

      return dispatch(actions.subscribeSuccess({ boardId, subscribed: true }));
    } catch (error: any) {
      return onError({ error, dispatch, action: actions.subscribeError({ error }) });
    }
  };
};

export const unsubscribe = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.subscribeRequest());

    try {
      await api.unsubscribe({ communityId, roomId, boardId, id });

      return dispatch(actions.subscribeSuccess({ boardId, subscribed: false }));
    } catch (error: any) {
      return onError({ error, dispatch, action: actions.subscribeError({ error }) });
    }
  };
};

export const fetchSubscribers = ({
  communityId,
  roomId,
  boardId,
  id,
}: {
  communityId: string;
  roomId: string;
  boardId: string;
  id: string;
}) => {
  return async (dispatch: Dispatch) => {
    dispatch(actions.fetchSubscribersRequest({ id }));

    try {
      const subscriptions = await api.fetchSubscribers({ communityId, roomId, boardId, id });

      return dispatch(actions.fetchSubscribersSuccess({ subscriptions }));
    } catch (error: any) {
      return onError({ error, dispatch, action: actions.fetchSubscribersError({ error }) });
    }
  };
};
